import "./index.css";
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
var Skeleton = forwardRef(function (_ref, ref) {
  var className = _ref.className,
    height = _ref.height,
    width = _ref.width;
  return jsx("div", {
    ref: ref,
    style: {
      height: height,
      width: width
    },
    "data-testid": "skeleton-block",
    className: classNames('cds-skeleton', className)
  });
});
export { Skeleton };